import React from 'react';

import styles from './ApplicationsTable.module.scss';

type TProps = {
  children: React.ReactNode;
};

export const ApplicationsTableWrapper = ({ children }: TProps) => (
  <div className={styles.ApplicationsTable__Wrapper}>{children}</div>
);
